"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRectSizeElementwise = void 0;
var updateRectSizeElementwise = function (from, updateFn) {
    return from.withMutations(function (rect) {
        return rect.update('width', updateFn).update('height', updateFn);
    });
};
exports.updateRectSizeElementwise = updateRectSizeElementwise;
